import { ArrowRight, Calendar, MapPin, Star } from "lucide-react";
import { Link } from "react-router-dom";
import { ARTICLES } from "@/data/teamData";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export default function Blog() {
  return (
    <section id="berita" data-testid="blog-section" className="bg-[#0A1128] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-24">
        <div className="mb-12 max-w-2xl">
          <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">REVIEW VENUE</div>
          <h2 className="font-display text-5xl sm:text-6xl leading-none">
            REVIEW <span className="text-[#E63946]">LAPANGAN</span>
          </h2>
          <p className="mt-4 text-white/70">
            Pengalaman langsung The 30s FF menjajal berbagai lapangan dan stadion di Jogja —
            dari kualitas rumput, fasilitas, sampai sensasi bermainnya.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ARTICLES.map((a, i) => (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              data-testid={`blog-card-${i}`}
              className="group flex flex-col bg-[#050B14] border border-white/10 hover:border-[#E63946] transition-colors overflow-hidden"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 bg-[#E63946] text-white text-[10px] font-bold tracking-wider px-3 py-1">
                  {a.category}
                </span>
                {a.rating && (
                  <span className="absolute top-3 right-3 inline-flex items-center gap-1 bg-black/70 backdrop-blur-sm text-white text-xs font-bold px-2.5 py-1">
                    <Star size={12} className="text-[#FFD60A] fill-[#FFD60A]" /> {a.rating}
                  </span>
                )}
              </div>
              <div className="flex flex-col flex-1 p-5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-white/50 text-xs mb-3">
                  <span className="inline-flex items-center gap-1.5">
                    <Calendar size={13} /> {formatDate(a.date)}
                  </span>
                  {a.location && (
                    <span className="inline-flex items-center gap-1.5">
                      <MapPin size={13} /> {a.location}
                    </span>
                  )}
                </div>
                <h3 className="font-display text-2xl leading-tight mb-2 group-hover:text-[#E63946] transition-colors">
                  {a.title}
                </h3>
                <p className="text-sm text-white/70 line-clamp-3 flex-1">{a.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-2 text-xs font-bold tracking-wider text-[#E63946]">
                  BACA SELENGKAPNYA <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
